"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockOrganizationDetail = exports.mockOrganization = void 0;
function mockOrganization(overrides = {}) {
    return {
        banner_image: 'https://omnia-fishing.imgix.net/sandbox/organizations/1/aglajergaleknbragujeianklaeng.jpg?auto=format',
        benefits_tier: 'tier_1',
        city: 'mock city',
        description: 'mock description',
        image: 'mock image',
        img_alt: 'https://omnia-fishing.imgix.net/sandbox/organizations/1/vaeiogiyuabhralkjthlaiererlejn.jpg?auto=format',
        instagram: 'instagram',
        meta_description: 'mock meta_description',
        meta_title: 'mock meta_title',
        name: 'mock name',
        restrict_membership: false,
        slug: 'mock slug',
        state: 'MN',
        street: 'mock street',
        website: 'mock website',
        zip_code: '12345',
        facebook: 'facebook',
        twitter: 'twitter',
        youtube: 'youtube',
        ...overrides,
    };
}
exports.mockOrganization = mockOrganization;
function mockOrganizationDetail(overrides = {}) {
    return {
        ...mockOrganization(overrides),
        members: [],
        ...overrides,
    };
}
exports.mockOrganizationDetail = mockOrganizationDetail;
